import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Box,
  Text
} from '@chakra-ui/react';

export const RichTextPreview = ({
  isOpen,
  onClose,
  content,
  type,
  subject
}) => {
  const wrapTextContent = (text) => `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <style>
          body {
            font-family: monospace;
            white-space: pre-wrap;
            padding: 16px;
            margin: 0;
            line-height: 1.5;
          }
        </style>
      </head>
      <body>${text}</body>
    </html>
  `;

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      size="full"
    >
      <ModalOverlay />
      <ModalContent maxW="90vw" h="95vh" my="2.5vh" display="flex" flexDirection="column">
        <ModalHeader p={4} flexShrink={0}>
          Preview {type === 'html' ? 'HTML' : 'Text'} Version
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={4} flex={1} display="flex" flexDirection="column" overflow="hidden">
          <Box flex={1} display="flex" flexDirection="column">
            <Text fontWeight="bold" mb={2}>Subject: {subject}</Text>
            <Box flex={1} display="flex" minH={0} borderWidth="1px" borderRadius="md">
              <Box
                flex={1}
                p={4}
                minH="full"
                overflowY="auto"
                sx={{
                  iframe: {
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }
                }}
              >
                <iframe 
                  srcDoc={type === 'html' ? content : wrapTextContent(content)} 
                  title="Email Preview" 
                />
              </Box>
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter borderTopWidth="1px" bg="gray.50" p={4} flexShrink={0}>
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RichTextPreview;
